import { useState } from "react";
import api from "@/api/client";
import { X, KeyRound, Eye, EyeOff } from "lucide-react";

export default function ChangePasswordModal({ onClose, onDone }) {
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");

  const submit = async () => {
    setErr(""); setOk("");
    if (pw.length < 6) return setErr("كلمة المرور الجديدة يجب ألا تقل عن 6 أحرف");
    if (pw !== confirm) return setErr("تأكيد كلمة المرور غير مطابق");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      setOk("تم تحديث كلمة المرور بنجاح");
      setCur(""); setPw(""); setConfirm("");
      setTimeout(() => onDone?.(), 1200);
    } catch (e) {
      setErr(e?.response?.data?.detail || "فشل تغيير كلمة المرور");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="change-password-modal">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}/>
      <div className="relative bg-white rounded-3xl w-full max-w-md p-5 talabya-shadow-float animate-fade-up">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-black text-lg flex items-center gap-2" style={{fontFamily:"Cairo"}}><KeyRound size={18} className="text-primary-brand"/> تغيير كلمة المرور</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[var(--surface-alt)] flex items-center justify-center" data-testid="close-pwd"><X size={16}/></button>
        </div>

        {[{label:"كلمة المرور الحالية", v:cur, set:setCur, tid:"pwd-current"},
          {label:"كلمة المرور الجديدة (٦ أحرف على الأقل)", v:pw, set:setPw, tid:"pwd-new"},
          {label:"تأكيد كلمة المرور الجديدة", v:confirm, set:setConfirm, tid:"pwd-confirm"}].map((f, i) => (
          <div key={i} className="mt-3 relative">
            <label className="block text-xs font-bold text-[var(--text-secondary)] mb-1">{f.label}</label>
            <input
              type={show ? "text" : "password"}
              value={f.v}
              onChange={(e) => f.set(e.target.value)}
              className="w-full px-4 py-3 pr-10 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none"
              data-testid={f.tid}
            />
            {i === 0 && (
              <button type="button" onClick={() => setShow(!show)} className="absolute top-9 left-3 text-[var(--text-secondary)]" data-testid="toggle-pwd-show">
                {show ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            )}
          </div>
        ))}

        {err && <div className="mt-3 text-sm bg-red-50 text-red-600 px-3 py-2 rounded-lg" data-testid="pwd-err">{err}</div>}
        {ok && <div className="mt-3 text-sm bg-green-50 text-green-700 px-3 py-2 rounded-lg" data-testid="pwd-ok">{ok}</div>}

        <div className="mt-5 flex gap-2">
          <button onClick={onClose} className="flex-1 py-3 rounded-xl bg-[var(--surface-alt)] text-[var(--text-secondary)] font-bold">إلغاء</button>
          <button onClick={submit} disabled={busy || !cur || !pw || !confirm} className="flex-1 py-3 rounded-xl bg-primary-brand text-white font-black disabled:opacity-60" data-testid="save-pwd">
            {busy ? "جاري..." : "حفظ كلمة المرور"}
          </button>
        </div>
      </div>
    </div>
  );
}
